const STORAGE_KEY = 'viewedProducts';
const MAX_RECENT_PRODUCTS = 12;

const normalizeProductId = (value) => {
  if (typeof value !== 'string') return '';
  return value.trim();
};

const sanitizeProductList = (list) => {
  if (!Array.isArray(list)) return [];

  return list.reduce((acc, value) => {
    const normalized = normalizeProductId(value);
    if (!normalized) return acc;
    acc.push(normalized);
    return acc;
  }, []);
};

// Manages a capped list of recently viewed product IDs in localStorage
export class RecentlyViewed {
  static addProduct(productId) {
    const normalizedId = normalizeProductId(productId);
    if (!normalizedId) return;

    const deduped = this.getProducts().filter((id) => id !== normalizedId);
    this.#writeProducts([normalizedId, ...deduped].slice(0, MAX_RECENT_PRODUCTS));
  }

  static clearProducts() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      // Storage unavailable.
    }
  }

  static getProducts() {
    const parsedList = this.#readProducts();
    const sanitizedList = sanitizeProductList(parsedList);

    if (!sanitizedList.length) {
      if (Array.isArray(parsedList) && parsedList.length) {
        this.clearProducts();
      }
      return [];
    }

    if (!Array.isArray(parsedList) || parsedList.length !== sanitizedList.length) {
      this.#writeProducts(sanitizedList);
    }

    return sanitizedList;
  }

  static getMaxProducts() {
    return MAX_RECENT_PRODUCTS;
  }

  static getStorageKey() {
    return STORAGE_KEY;
  }

  static #readProducts() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      return JSON.parse(raw);
    } catch {
      return [];
    }
  }

  static #writeProducts(products) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    } catch (error) {
      if (error?.name !== 'QuotaExceededError') return;

      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(products.slice(0, MAX_RECENT_PRODUCTS >> 1)));
      } catch {
        this.clearProducts();
      }
    }
  }
}
